export const product = {
  brand: 'Buena VibraX',
  title: 'La vergüenza es de pobre',
  titleTail: 'de espíritu',
  author: 'Juan Carlos Adrianza',
  price: '$8.50 USD',
  priceAmount: '$8.50',
  priceCurrency: 'USD',
  compareAtPrice: '$25.00',
  savingsAmount: '$16.50',
  savingsPercent: '66 %',
  priceNote: 'Pago único',
  ctaLabel: 'Quiero leer este libro',
  // Enlace de carrito de Shopify: añade 1 unidad del ebook y lleva directo al carrito.
  productUrl: 'https://buenavibrax.com/cart/50741726871609:1',
  // Imagen aprobada y bloqueada: mockup del ebook. No regenerar ni modificar.
  mockupImage:
    'https://cdn.magicpatterns.com/uploads/ennkUxe1d65bvkNNtbQ3PB/Elige_Actuar__Mockup_Editorial_Dorado.png',
  // Fotografía aprobada: persona trabajando con RESET 21.
  resetImage:
    'https://cdn.magicpatterns.com/patterns/generated-images/ef4016c3-6a23-4f8d-8224-9b786f404930.jpg',
  identificationImage:
    'https://cdn.magicpatterns.com/patterns/generated-images/7540bd46-13a9-4fd2-ba8d-1b9461094ade.jpg',
}

export const waitingLines = [
  'Esperamos estar listos.',
  'Esperamos aprobación.',
  'Esperamos el momento perfecto.',
]

export const bookThemes = [
  {
    title: 'De dónde nace la vergüenza',
    body: 'Reconocer las voces que aprendiste a obedecer sin darte cuenta.',
  },
  {
    title: 'Tu valor no se vota',
    body: 'Separar lo que eres de lo que otros opinan sobre ti.',
  },
  {
    title: 'El primer paso imperfecto',
    body: 'Empezar con lo que tienes, sin esperar a sentirte preparado.',
  },
]

export const bookFacts = [
  { value: '67', label: 'páginas' },
  { value: '8', label: 'capítulos' },
  { value: 'RESET 21', label: 'programa práctico' },
]

export const changeSteps = [
  { icon: 'read', title: 'Lee', body: 'Reconoce los miedos que te han detenido.' },
  { icon: 'reflect', title: 'Reflexiona', body: 'Descubre qué decisiones sigues postergando.' },
  { icon: 'act', title: 'Actúa', body: 'Pon en práctica RESET 21, un día a la vez.' },
] as const

// Rutas nativas de políticas en Shopify (Configuración › Políticas).
export const legalLinks = [
  { label: 'Política de privacidad', href: '/policies/privacy-policy' },
  { label: 'Términos y condiciones', href: '/policies/terms-of-service' },
]

export const purchaseDetails = ['PDF digital', 'Descarga por correo electrónico', 'Pago seguro']

export const faqs = [
  {
    question: '¿Este libro es para mí?',
    answer:
      'Si alguna vez has dejado de intentar algo por vergüenza, inseguridad o miedo al qué dirán, encontrarás reflexiones y ejercicios que pueden ayudarte a dar el primer paso.',
  },
  {
    question: '¿Qué voy a encontrar en sus páginas?',
    answer:
      '67 páginas, 8 capítulos y RESET 21: un recorrido para reconocer lo que te detiene, cuestionar tus miedos y comenzar a actuar.',
  },
  {
    question: '¿Qué es RESET 21?',
    answer:
      'Es un programa práctico incluido en el ebook, con ejercicios para 21 días. No se trata solo de leer, sino de aplicar lo aprendido a tu vida cotidiana.',
  },
  {
    question: '¿Necesito experiencia o conocimientos previos?',
    answer:
      'No. Está escrito en un lenguaje cercano y directo. Solo necesitas disposición para reflexionar y avanzar a tu propio ritmo.',
  },
  {
    question: '¿Cómo recibo el libro después de comprarlo?',
    answer:
      'Recibirás un correo electrónico con el enlace de descarga del PDF, que podrás leer en tu teléfono, tablet o computadora.',
  },
  {
    question: '¿Es un pago único? ¿RESET 21 tiene costo adicional?',
    answer:
      'Sí, pagas una sola vez $8.50 USD. RESET 21 ya está incluido, sin suscripciones ni cargos adicionales por el programa.',
  },
]
